import { useTranslation } from "react-i18next";
import { Controller, useFormContext } from "react-hook-form";
import { FormControl, FormLabel, TextField } from "@mui/material";

import { EditEntityProfileData } from "../../../../../types/editEntityProfile-type";

const EntityAboutField = () => {
  const { t } = useTranslation("profiles", { keyPrefix: "entityProfileEdit" });
  const { control } = useFormContext<EditEntityProfileData>();

  return (
    <Controller
      name="about"
      control={control}
      render={({ field, fieldState: { error } }) => (
        <>
          <FormControl error={!!error} fullWidth>
            <FormLabel
              sx={{
                color: "var(--Dark---800, #414141)",
                fontFamily: "Montserrat",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "24px",
              }}
            >
              {t("about")}
            </FormLabel>
            <TextField
              {...field}
              multiline
              rows={4}
              placeholder={t("enterAbout")}
              error={!!error}
              helperText={error?.message && t(error.message)}
              sx={{
                "& .MuiInputBase-root": {
                  borderRadius: "8px",
                },
              }}
            />
          </FormControl>
        </>
      )}
    />
  );
};

export default EntityAboutField;
